// extracted by mini-css-extract-plugin
export default {"Label":"IssueTemplateBanner-module__Label--GTasc","Banner":"IssueTemplateBanner-module__Banner--kvXxt"};